import styled from 'styled-components';

/**
 * @since 8.0.0
 */
var TableHeaderCellLabelWrapper = /*#__PURE__*/styled.span.withConfig({
  displayName: "TableHeaderCellLabelWrapper",
  componentId: "c11n-8-111-1__sc-16w2del-0"
})([""]);
TableHeaderCellLabelWrapper.displayName = 'TableHeaderCellLabelWrapper';

/** @component */
export { TableHeaderCellLabelWrapper };